import { object, string, InferType, boolean} from 'yup'
import { useFormContext } from '../context/FormContext'
import { FormHelperText, TextField, FormControl, FormControlLabel, FormGroup, Checkbox, Box } from '@mui/material'

export const certificatesSchema = object({
    basicSafety: boolean(),
    medicalCertificate: boolean(),
    rhibLicense: boolean(),
    additionalCertificates: string(),
})

export interface CertificatesData extends InferType<typeof certificatesSchema> {}

const CertificatesScreen = () => {

    const {
        formData, formik, labels
    } = useFormContext()

    const {
        basicSafety, medicalCertificate, rhibLicense, additionalCertificates
    } = formData

    if (!formik) {
        return null
    }

    const { setFieldValue, handleBlur, touched, errors, handleChange } = formik

    const _handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue(event.target.name, event.target.checked)
    }

    return (
        <Box width="100%" className="screen-about">
            <div className="react-form-title">
                <h2>{labels.certificates.title}</h2>
            </div>
            <FormControl sx={{ mb: '20px', width: '100%'}}>
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox checked={basicSafety} onChange={_handleChange} name="basicSafety" />}
                        label={labels.certificates.basicSafety}
                        sx={{mb: '10px'}}
                    />
                    <FormControlLabel
                        control={<Checkbox checked={medicalCertificate} onChange={_handleChange} name="medicalCertificate" />}
                        label={labels.certificates.medicalCertificate}
                        sx={{ mb: '10px' }}
                    />  
                    <FormControlLabel
                        control={<Checkbox checked={rhibLicense} onChange={_handleChange} name="rhibLicense"  />}
                        label={labels.certificates.rhibLicense}
                        sx={{mb: '10px'}}
                    />
                </FormGroup>
            </FormControl>
            <TextField
                id="additionalCertificates"
                label={labels.certificates.additionalCertificates}
                value={additionalCertificates}
                onBlur={handleBlur}
                onChange={handleChange}
                error={touched.additionalCertificates && Boolean(errors.additionalCertificates)}
                helperText={touched.additionalCertificates && errors.additionalCertificates}
                name='additionalCertificates'
                variant="standard"
                sx={{ width: '100%', '@media (min-width: 1024px)': { height: '80px', width: 'calc(50% - 20px)' } }}
            />
            <FormHelperText sx={{ fontSize: '13px', lineHeight: '21px', letterSpacing: '0.169px' }}>
                {labels.certificates.additionalCertificatesPlaceholder}
            </FormHelperText>
        </Box>
    )
}

export default CertificatesScreen